import { FormProvider, useForm } from "react-hook-form";
import { MuniSpinner2, TextInput } from "../../../components";
import { Button } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { busquedaPorDominioSchema } from "./schemas";
import { handleBusquedaPorDominio } from "./handlers";
import { SearchIcon } from "../../../components/Icons";
import { useEffect } from "react";

const FormBusquedaPorDominio = (props) => {
  const { setInfracciones, setErrorNoHayInfraccion, setCountdown, setValor, setDatosSobre, setCorreoElectronico,setConstancia } = props;

  const methods = useForm({
    mode: "all",
    resolver: yupResolver(busquedaPorDominioSchema),
    defaultValues: {
      datos_sobre: "dominio",
      valor: "",
    },
  });

  useEffect(() => {
    methods.resetField("valor");
  }, [methods.watch("datos_sobre")]);

  const datosSobreDominio = methods.watch("datos_sobre")?.trim().toUpperCase() === "DOMINIO";

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit((data) =>
          handleBusquedaPorDominio(
            data,
            setInfracciones,
            setErrorNoHayInfraccion,
            setCountdown,
            setValor,
            setDatosSobre,
            setConstancia
          )
        )}
      >
        <fieldset className="d-flex flex-column gap-3" disabled={methods.formState.isSubmitting}>
          <div>
            <label className="mb-2">Quiero datos sobre</label>
            <div className="d-flex flex-column flex-sm-row align-items-sm-center gap-2 gap-sm-4 cursor-pointer">
              <div className="d-flex gap-2">
                <input
                  className="form-check-input"
                  type="radio"
                  id="input-dominio"
                  value={"dominio"}
                  // onClick={() => methods.setValue('datos_sobre', 'dominio')}
                  {...methods.register("datos_sobre")}
                />
                <label
                  htmlFor="input-dominio"
                  className="label-busqueda-dominio"
                  style={{ marginTop: "2px" }}
                >
                  Una patente
                </label>
              </div>
              <div className="d-flex gap-2">
                <input
                  className="form-check-input"
                  type="radio"
                  id="input-documento"
                  value={"documento"}
                  // onClick={() => methods.setValue('datos_sobre', 'documento')}
                  {...methods.register("datos_sobre")}
                />
                <label
                  htmlFor="input-documento"
                  className="label-busqueda-dominio"
                  style={{ marginTop: "2px" }}
                >
                  Un documento / CUIT
                </label>
              </div>
            </div>
          </div>

          {datosSobreDominio || methods.watch("datos_sobre") === "documento" ? (
            <div>
              <label htmlFor="valor">
                {datosSobreDominio ? "Dominio *" : "Documento / CUIT *"}
              </label>
              <input
                id="valor"
                className={
                  "form-control mb-0" +
                  (methods.formState.errors["valor"] ? " border border-danger " : "")
                }
                {...methods.register("valor")}
                type={datosSobreDominio ? "text" : "number"}
                maxLength={datosSobreDominio ? 7 : 11}
                onInput={(e) => {
                  if (e.target.value.length > e.target.maxLength) {
                    e.target.value = e.target.value.substring(0, 11);
                    return false;
                  }

                  return true;
                }}
                onKeyDown={(e) => {
                  if (datosSobreDominio) return true;

                  const teclasNoPermitidas = [
                    "KeyE",
                    "ArrowUp",
                    "ArrowDown",
                    "Minus",
                    "Plus",
                    "Equal",
                    "Comma",
                    "Period",
                    "Space",
                  ];
                  const noEsTeclaPermitida = teclasNoPermitidas.includes(e.code);
                  if (noEsTeclaPermitida) {
                    e.stopPropagation();
                    e.preventDefault();
                    return false;
                  }

                  return true;
                }}
              />
              {methods.formState.errors["valor"] && (
                <small className="fw-semibold text-danger mb-0 mt-2 d-block">
                  {methods.formState.errors["valor"]?.message}
                </small>
              )}
            </div>
          ) : (
            <small className="text-danger fw-semibold">Debe seleccionar una opción</small>
          )}

          {/* <TextInput
            name="correo_electronico"
            label="Correo Electrónico"
          /> */}

          <Button
            type="submit"
            disabled={methods.formState.isSubmitting}
            size="lg"
            className="d-flex justify-content-center mt-2"
          >
            {methods.formState.isSubmitting ? (
              <span className="d-flex align-items-center gap-1">
                <MuniSpinner2
                  width="18px"
                  height="18px"
                  circularProgressSize={24}
                  circularProgressColor="#ffffff"
                  fileName="bola-blanca.png"
                />
              </span>
            ) : (
              <SearchIcon />
            )}
          </Button>
        </fieldset>
      </form>
      {methods.watch("datos_sobre") === "dominio" ? (
        <div className="mt-3 mb-0 alert alert-primary" role="alert">
          <p className="mb-0">Formatos de dominio admitidos: </p>
          <div
            className="d-flex flex-column flex-sm-row flex-wrap gap-sm-2"
            style={{ marginBottom: "0" }}
          >
            <span>
              {" "}
              AAA111 <span className="d-none d-sm-inline">/</span>{" "}
            </span>
            <span>
              {" "}
              111AAA <span className="d-none d-sm-inline">/</span>{" "}
            </span>
            <span>
              {" "}
              AA111AA <span className="d-none d-sm-inline">/</span>{" "}
            </span>
            <span> A111AAA </span>
          </div>
        </div>
      ) : (
        <div className="mt-3 mb-0 alert alert-primary" role="alert">
          <div>
            <p className="mb-0">Formato de documento valido:</p>
            <div
              className="d-flex flex-column flex-sm-row flex-wrap gap-sm-2"
              style={{ marginBottom: "0" }}
            >
              <span> 1234567 / 12345678</span>
            </div>
          </div>
          <br />
          <div>
            <p className="mb-0">Formato CUIT valido:</p>
            <div
              className="d-flex flex-column flex-sm-row flex-wrap gap-sm-2"
              style={{ marginBottom: "0" }}
            >
              <span> 10123456789</span>
            </div>
          </div>
        </div>
      )}
    </FormProvider>
  );
};

export default FormBusquedaPorDominio;
